<template lang="pug">
  div
    .title {{ title }}
    v-row
      v-col(
        v-for="item in items",
        :key="item.id",
        sm="4",
      )
        v-checkbox(      
          dense,
          hide-details,  
          v-model="currentValue",
          :value="item.id",
          :label='item.name',
          :error="$attrs['error-messages'] !== undefined",
        )
    .subtitle.error--text {{ $attrs['error-messages'] }}
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: true,
    },

    items: {
      type: Array,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },
  },

  computed: {
    currentValue: {
      get: function() {
        return this.value;
      },

      set: function(updatedValue) {
        this.$emit('update:value', updatedValue);
      },
    },
  },
};
</script>
